<script setup>
import { computed, inject } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>

<template>
  <div class="bg-primary">
    <div class="section-container">
      <div class="bg-white p-6 md:p-12 rounded-lg shadow-lg">
        <!-- Title -->
        <h2 class="text-4xl md:text-4xl">{{ $t('Kwaliteitsborging voor zorginstellingen') }}</h2>

        <!-- Step Process -->
        <div class="mt-8 flex justify-center items-center">
          <div class="relative flex flex-col md:flex-row w-full">
            <!-- Horizontal Line -->
            <div class="absolute top-6 left-0 w-full h-1 bg-gray-300"></div>

            <!-- Step 1 -->
            <div class="w-full md:w-1/4 text-center relative mb-6 md:mb-0">
              <div
                class="inline-flex items-center justify-center w-12 h-12 bg-[#A5C9B1] text-white text-xl font-bold rounded-md z-10"
              >1</div>
              <div
                class="absolute top-12 left-1/2 transform -translate-x-1/2 w-0.5 h-6 bg-gray-300"
              ></div>
              <h3 class="mt-6 text-xl font-semibold">{{ $t('Screening') }}</h3>
              <p
                class="mt-2 text-lg text-gray-700"
              >{{ $t('Alle zorgprofessionals worden door Zorgblik gescreend op hun opleiding, ervaring en kwalificaties.') }}</p>
            </div>

            <!-- Step 2 -->
            <div class="w-full md:w-1/4 text-center relative mb-6 md:mb-0">
              <div
                class="inline-flex items-center justify-center w-12 h-12 bg-[#A5C9B1] text-white text-xl font-bold rounded-md z-10"
              >2</div>
              <div
                class="absolute top-12 left-1/2 transform -translate-x-1/2 w-0.5 h-6 bg-gray-300"
              ></div>
              <h3 class="mt-6 text-xl font-semibold">{{ $t('Referenties') }}</h3>
              <p
                class="mt-2 text-lg text-gray-700"
              >{{ $t('Wij controleren de referenties van onze zorgprofessionals om de kwaliteit te waarborgen.') }}</p>
            </div>

            <!-- Step 3 -->
            <div class="w-full md:w-1/4 text-center relative mb-6 md:mb-0">
              <div
                class="inline-flex items-center justify-center w-12 h-12 bg-[#A5C9B1] text-white text-xl font-bold rounded-md z-10"
              >3</div>
              <div
                class="absolute top-12 left-1/2 transform -translate-x-1/2 w-0.5 h-6 bg-gray-300"
              ></div>
              <h3 class="mt-6 text-xl font-semibold">{{ $t('VOG') }}</h3>
              <p
                class="mt-2 text-lg text-gray-700"
              >{{ $t('Voor alle functies vragen we een Verklaring Omtrent Gedrag (VOG) van onze zorgprofessionals.') }}</p>
            </div>

            <!-- Step 4 -->
            <div class="w-full md:w-1/4 text-center relative">
              <div
                class="inline-flex items-center justify-center w-12 h-12 bg-[#A5C9B1] text-white text-xl font-bold rounded-md z-10"
              >4</div>
              <div
                class="absolute top-12 left-1/2 transform -translate-x-1/2 w-0.5 h-6 bg-gray-300"
              ></div>
              <h3 class="mt-6 text-xl font-semibold">{{ $t('Evaluatie') }}</h3>
              <p
                class="mt-2 text-lg text-gray-700"
              >{{ $t('Na plaatsing van de zorgprofessional evalueren wij de samenwerking om te zorgen voor een optimale werksituatie.') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
